import { filterXSS } from 'xss';

/** Allowlist for shipping-notes HTML: simple formatting and links only. */
const SHIPPING_NOTES_WHITE_LIST: Record<string, string[]> = {
    a: ['href', 'title', 'target'],
    b: [],
    br: [],
    div: [],
    em: [],
    i: [],
    li: [],
    ol: [],
    p: [],
    span: [],
    strong: [],
    u: [],
    ul: []
};

/** Sanitize HTML intended for shipping-notes display (strips scripts, handlers, disallowed tags). */
export const sanitizeShippingNotesHtml = (html: string): string =>
    filterXSS(html, {
        whiteList: SHIPPING_NOTES_WHITE_LIST,
        stripIgnoreTag: true,
        stripIgnoreTagBody: ['script', 'style']
    });
